<template>
  <div class="exito-wrapper px-5 px-sm-10">
    <div class="row mx-auto px-md-10 align-items-center">
      <div class="col-lg-1 col-md-1 d-none d-md-block"></div>
      <div class="col-lg-4 col-md-4 d-none d-md-block">
        <div class="exito-imagen-container">
          <img class="exito-imagen-piloto" :src="require('@/assets/2026/predicciones_enviadas.jpg')" alt="Predicciones Enviadas" />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="contenedor-mensaje">
          <p class="font-white font-bold exito-titulo italic">Tus Predicciones<br>han sido enviadas.</p>
          <p class="font-white font-regular exito-texto">¡Mucha Suerte!</p>
          <button class="font-bold exito-boton italic" @click="volverADashboard">Regresar al dashboard</button>
        </div>
      </div>
      <div class="col-lg-1 col-md-1 d-none d-md-block"></div>
    </div>
  </div>
</template>

<!-- <script src="./exito.js" /> -->
<style src="./prediccionesEnviadas.scss" lang="scss" />
<script>
// import axios from 'axios'
export default {
  data() {
    return {
      name_race: '',
      circuito: '',
      ciudad: ''
    }
  },
  methods: {
    volverAPredicciones() {
      this.$router.push('/predicciones-pilotos-max')
    },
    volverADashboard() {
      this.$router.push('/dashboard')
    }
    // obtenerCarrera() {
    //   axios
    //     .get('https://www.mobilpredictor.com.mx/datos/api/carreraActual')
    //     // .get('http://127.0.0.1:8000/api/carrera')
    //     // .get('https://api.mobilpredictor2025.vmtec.com.mx/api/carreraActual')
    //     .then((response) => {
    //       const raceData = response.data
    //       // Para la vista
    //       this.name_race = JSON.stringify(raceData.carrera.name)
    //       this.circuito = JSON.stringify(raceData.carrera.circuit)
    //       this.ciudad = JSON.stringify(raceData.carrera.city)
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // }
  },
  mounted() {
    window.fbq('track', 'CompleteRegistration')
    // this.obtenerCarrera()
  }
}
</script>
